import signedFetch from '../../../apiCalls/util/signedFetch.js';

export default function* productUploadLogsApi() {
  return yield signedFetch('product-upload-logs', `${__API_BASE__}/products/last-update-date`, 'GET');
}
